import { IonContent, IonIcon, IonModal } from "@ionic/react";
import dayjs from "dayjs";
import {
  closeCircleOutline,
  ellipsisHorizontalOutline,
  imageOutline,
  navigateOutline,
  pauseCircle,
  peopleOutline,
  playCircle,
  returnUpBackOutline,
  returnUpForwardOutline,
  trashOutline,
  videocamOutline,
  volumeHighOutline,
} from "ionicons/icons";
import React, { useState } from "react";
import { findDOMNode } from "react-dom";
import ReactPlayer from "react-player";
import { Popover } from "react-tiny-popover";
import * as screenfull from "screenfull";
import { Screenfull } from "screenfull";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import "./userMessageCardComponentStyle.scss";
import { utilService } from "../../../services/utilService";
import { MembersCard } from "../membersCard/MembersCard";

export const UserMessageCardComponent = ({
  message,
  handleReply,
  handleForward,
  handleDelete,
}: any) => {
  const [player, setPlayer]: any = useState({});
  const [isMessageActionPopoverOpen, serIsMessageActionPopoverOpen] =
    useState(false);
  const [isRecieversListPopoverOpen, serIsRecieversListPopoverOpen] =
    useState(false);
  const viewVideo = () => {
    (screenfull as Screenfull).request(findDOMNode(player) as any);
  };

  const [isOpenMbrSpecialityContainer, setIsOpenMbrSpecialityContainer] =
    useState<boolean>(false);
  const [mbrSpecialityValues, setMbrSpecialityValues] = useState<any>([]);

  const mediaItem =
    Array.isArray(message?.media_data) && message.media_data.length > 0
      ? message.media_data[0]
      : message?.media_data && typeof message?.media_data === "object"
      ? message.media_data
      : null;

  const rawMediaType = String(
    mediaItem?.media_type ?? mediaItem?.type ?? message?.recent_message_type ?? ""
  ).toLowerCase();

  const isImageMedia =
    rawMediaType === "image" ||
    rawMediaType === "1" ||
    mediaItem?.media_type === 1 ||
    mediaItem?.type === 1;

  const isAudioMedia =
    rawMediaType === "audio" ||
    rawMediaType === "2" ||
    mediaItem?.media_type === 2 ||
    mediaItem?.type === 2;

  const rawUrl =
    mediaItem?.url ||
    mediaItem?.nativeURL ||
    mediaItem?.media_url ||
    mediaItem?.path ||
    "";

  const resolvedMediaUrl =
    rawUrl.startsWith("http") ||
    rawUrl.startsWith("blob:") ||
    rawUrl.startsWith("data:")
      ? rawUrl
      : rawUrl
      ? `${utilService.getBaseUrl()}/${rawUrl.replace(/^\//, "")}`
      : "";

  const viewWebImage = (id: Number) => {
    const img: any = document.getElementById(`media-${id}`);
    const viewer = new Viewer(img, {
      backdrop: true,
      button: false,
      toolbar: 0,
      hide() {
        viewer.destroy();
      },
    });
    viewer.show();
  };

  const viewItem = (type: string, id: Number) => {
    switch (type) {
      case "Video":
        viewVideo();
        break;
      case "Image":
        viewWebImage(id);
        break;
    }
  };

  const ActionPopoverContent = () => {
    return (
      <div className="action-popover-container">
        <div
          className="action-btn-container"
          onClick={() => handleReply(message)}
        >
          <IonIcon icon={returnUpBackOutline} />
          <p>Reply</p>
        </div>
        {!mediaItem?.is_media_expired && (
          <div
            className="action-btn-container"
            onClick={() => handleForward(message)}
          >
            <IonIcon icon={returnUpForwardOutline} />
            <p>Forward</p>
          </div>
        )}
        <div
          className="action-btn-container"
          onClick={() => handleDelete(message)}
        >
          <IonIcon icon={trashOutline} />
          <p>Delete</p>
        </div>
      </div>
    );
  };

  return (
    <>
      {message?.request_type === "info" ? (
        <div className="info-message-container">
          <p>{message?.message_text}</p>
        </div>
      ) : (
        <div
          className={`${
            message?.request_type === "send"
              ? "sent-message-item"
              : "recieve-message-item"
          } triangle`}
        >
          <Popover
            isOpen={isMessageActionPopoverOpen}
            positions={[message?.request_type === "send" ? "left" : "right"]}
            padding={10}
            containerStyle={{
              marginTop: mediaItem?.is_media_expired
                ? "1.5rem"
                : "2.75rem",
              marginLeft:
                message?.request_type === "send" ? "-0.5rem" : ".5rem",
            }}
            onClickOutside={() => serIsMessageActionPopoverOpen(false)}
            content={({ position, childRect, popoverRect }) => (
              <ActionPopoverContent />
            )}
          >
            <div
              className="menu-icon left"
              onClick={() => serIsMessageActionPopoverOpen(true)}
            >
              <IonIcon icon={ellipsisHorizontalOutline} />
            </div>
          </Popover>
          {message?.is_group_sms && message?.request_type === "receive" && (
            <p className="from-user-name">{message?.from_user?.first_name}</p>
          )}
          {message?.is_group_sms && message?.request_type === "send" && (
            <Popover
              isOpen={isRecieversListPopoverOpen}
              positions={["top"]}
              padding={10}
              containerStyle={{
                marginLeft: "-2rem",
              }}
              onClickOutside={() => serIsRecieversListPopoverOpen(false)}
              content={({ position, childRect, popoverRect }) => (
                <div className="members-list-popover-container">
                  {message?.to_users?.map((member: any, index: number) => (
                    <MembersCard
                      key={member?.guid || index}
                      member={member}
                      isCallEnabled={false}
                      isSelectionEnabled={false}
                      setMbrSpecialityValues={setMbrSpecialityValues}
                      toggleSpecilityModal={() => {
                        serIsRecieversListPopoverOpen(false);
                        setIsOpenMbrSpecialityContainer(
                          !isOpenMbrSpecialityContainer
                        );
                      }}
                    />
                  ))}
                </div>
              )}
            >
              {message?.is_group_sms && message?.request_type === "send" && (
                <div
                  className="recievers-icon-container"
                  style={{
                    cursor: message?.is_sent_to_all ? "auto" : "pointer",
                  }}
                  onClick={() => {
                    if (!message?.is_sent_to_all) {
                      serIsRecieversListPopoverOpen(true);
                    }
                  }}
                >
                  {!message?.is_sent_to_all ? (
                    <IonIcon icon={peopleOutline} />
                  ) : (
                    <p>All</p>
                  )}
                  <IonIcon icon={navigateOutline} />
                </div>
              )}
            </Popover>
          )}
          <p className="date-txt">
            {message?.created_on
              ? dayjs(message?.created_on).isValid()
                ? dayjs(message?.created_on).format("HH:mm")
                : message?.created_on
              : "11:48"}
          </p>
          {message?.is_quoted_message && (
            <div>
              <QuotedMsg QuotedMsg={message?.quoted_message_data} />
            </div>
          )}
          <div
            style={{
              alignSelf: "flex-start",
              cursor:
                message?.message_has_media &&
                !mediaItem?.is_media_expired
                  ? "pointer"
                  : "auto",
            }}
            onClick={() => {
              if (
                message?.message_has_media &&
                !mediaItem?.is_media_expired &&
                !isAudioMedia
              ) {
                viewItem(mediaItem?.media_type, message?.id);
              }
            }}
          >
            {message?.message_text && message?.message_text !== mediaItem?.media_name && (
              <p className="msg-txt">{message?.message_text}</p>
            )}
            {(message?.message_has_media || !!mediaItem) && (
              <div
                className={
                  (message?.message_has_media || !!mediaItem) && message?.message_text
                    ? "msg-media-container"
                    : ""
                }
              >
                {isImageMedia && resolvedMediaUrl && (
                  <div
                    className="chat-image-attachment-container"
                    onClick={(e) => {
                      e.stopPropagation();
                      viewItem("Image", message?.id);
                    }}
                  >
                    <img
                      id={`media-${message?.id}`}
                      src={resolvedMediaUrl}
                      alt={mediaItem?.media_name || "Attachment"}
                      className="chat-inline-image"
                      onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                        const target = e.target as HTMLImageElement;
                        target.src = "assets/images/defaultProfilePic.png";
                      }}
                    />
                  </div>
                )}
                {mediaItem?.media_type === "Video" && (
                  <div className="media-message-container">
                    <IonIcon icon={videocamOutline} />
                    <p>{mediaItem?.media_name}</p>
                  </div>
                )}
                {isAudioMedia && resolvedMediaUrl && (
                  <VoiceNotePlayer url={resolvedMediaUrl} />
                )}
              </div>
            )}
            {mediaItem?.media_type === "Video" && (
              <ReactPlayer
                ref={(ref) => setPlayer(ref)}
                url={mediaItem?.url}
                light={false}
                controls={true}
                width={0}
                height={0}
              />
            )}
          </div>
          <SpecialityModal
            isOpen={isOpenMbrSpecialityContainer}
            onClose={() => {
              setIsOpenMbrSpecialityContainer(false);
              serIsRecieversListPopoverOpen(true);
            }}
            values={mbrSpecialityValues}
            title={"Speciality"}
          />
        </div>
      )}
    </>
  );
};

const QuotedMsg = ({ QuotedMsg }: any) => {
  return (
    <div className="reply-box">
      <p className="from-user-name">{QuotedMsg?.from_user?.first_name}</p>
      {QuotedMsg?.media_type == "Text" ? (
        <p>{QuotedMsg?.quoted_message}</p>
      ) : (
        <>
          {QuotedMsg?.media_type === "Image" && (
            <div className="media-message-container">
              <IonIcon icon={imageOutline} />
              <p>{QuotedMsg?.media_name}</p>
            </div>
          )}
          {QuotedMsg?.media_type === "Video" && (
            <div className="media-message-container">
              <IonIcon icon={videocamOutline} />
              <p>{QuotedMsg?.media_name}</p>
            </div>
          )}
          {QuotedMsg?.media_type === "Audio" && (
            <div className="media-message-container">
              <IonIcon icon={volumeHighOutline} />
              <p>{QuotedMsg?.media_name}</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const VoiceNotePlayer = ({ url }: { url: string }) => {
  const audioRef = React.useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  const formatTime = (seconds: number) => {
    if (!isFinite(seconds) || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
  };

  const handleSeek = (e: React.ChangeEvent<HTMLInputElement>) => {
    const audio = audioRef.current;
    if (!audio || !duration) return;
    const time = (Number(e.target.value) / 100) * duration;
    audio.currentTime = time;
    setCurrentTime(time);
  };

  const progressPercent = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div className="voice-note-player" onClick={(e) => e.stopPropagation()}>
      <audio
        ref={audioRef}
        src={url}
        preload="metadata"
        onLoadedMetadata={(e) => setDuration(e.currentTarget.duration)}
        onTimeUpdate={(e) => setCurrentTime(e.currentTarget.currentTime)}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => {
          setIsPlaying(false);
          setCurrentTime(0);
        }}
      />
      <div className="voice-note-play-btn" onClick={togglePlay}>
        <IonIcon icon={isPlaying ? pauseCircle : playCircle} />
      </div>
      <input
        type="range"
        className="voice-note-progress"
        min={0}
        max={100}
        value={progressPercent}
        onChange={handleSeek}
      />
      <span className="voice-note-time">
        {formatTime(isPlaying || currentTime ? currentTime : duration)}
      </span>
    </div>
  );
};

const SpecialityModal: React.FC<any> = ({ isOpen, onClose, values }) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onClose}
      className="speciality-modal"
    >
      <div className="header-section-container">
        <h2>Speciality</h2>
        <div className="close-container" onClick={onClose}>
          <IonIcon icon={closeCircleOutline} slot="end" />
        </div>
      </div>
      <IonContent>
        <div className="specialty-tag-container">
          {values?.map((value: any, index: number) => {
            return (
              <div key={index} className="specialty-tag">
                <p>{value}</p>
              </div>
            );
          })}
        </div>
      </IonContent>
    </IonModal>
  );
};
